module.exports = __webpack_public_path__ + "static/img/photojz.8a672aca.svg";